var map = {
	"./social-500px.svg": 82,
	"./social-dribbble.svg": 83,
	"./social-facebook.svg": 84,
	"./social-github.svg": 85,
	"./social-google.svg": 86,
	"./social-instagram.svg": 87,
	"./social-odnoklassniki.svg": 88,
	"./social-rediit.svg": 89,
	"./social-stackoverflow.svg": 90,
	"./social-steam.svg": 91,
	"./social-twitch.svg": 92,
	"./social-twitter.svg": 93,
	"./social-vkontakte.svg": 94,
	"./social-windows.svg": 95,
	"./social-yahoo.svg": 96
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars ^\.\/social\-.*\.svg$
// module id = 81
// module chunks = 0